// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { BroadcastMessageArgs_abstract } from './../abstract/SagaBase/BroadcastMessageArgs_abstract';
export class BroadcastMessageArgs extends BroadcastMessageArgs_abstract {}
